const investmentElecCollection = {
  state: {
    pageType: 'list',
    beginUpdate: new Date(),
    detailId: null
  },
  mutations: {
    set_investment_elec_collection_pageType (state, data) {
      state.pageType = data
    },
    set_investment_elec_collection_update (state, data) {
      state.beginUpdate = data
    },
    set_investment_elec_collection_id (state, data) {
      state.detailId = data
    }
  },
  getters: {

  },
  actions: {

  }
}
export default investmentElecCollection
